export const Heading = {
  baseStyle: {
    fontWeight: 'semibold',
  },
};
